export const translations = {
  no: {
    header: {
      login: 'Logg inn',
      languageLabel: 'Språk',
    },
    hero: {
      badge: 'KI-drevet fitness og ernæring',
      line1: 'TREN',
      line2: 'SMARTERE.',
      line3: 'LEV STERKERE.',
      sub: 'FitGainers samler personlige treningsøkter, måltidsplanlegging, kalorisporing og KI-genererte oppskrifter i én intelligent plattform. Din personlige coach, tilgjengelig 24/7 på ditt eget språk.',
      cta: 'Kom i gang nå',
      ctaSecondary: 'Slik fungerer det',
      stats: [
        { value: '24/7', label: 'KI-coach tilgjengelig' },
        { value: '1000+', label: 'Sunde oppskrifter' },
        { value: '500+', label: 'Treningsvideoer' },
      ],
      chat: [
        { from: 'user', text: 'Hva bør jeg spise etter dagens styrkeøkt?' },
        { from: 'ai', text: 'Basert på økten din anbefaler jeg 30 g protein innen 45 minutter. Skal jeg lage en oppskrift av ingrediensene du har hjemme?' },
        { from: 'user', text: 'Ja, gjerne!' },
      ],
      recipeCard: {
        tag: 'KI-generert oppskrift',
        title: 'Proteinrik bowl med kylling',
        kcal: '420 kcal',
        protein: '32 g protein',
        time: '15 min',
      },
      floating: [
        { title: 'Kalorier logget', value: '1 840 / 2 200 kcal' },
        { title: 'Ny økt klar', value: 'HIIT, 20 min' },
      ],
    },
    ticker: [
      'Personlige treningsøkter',
      'Ernæring og måltidsplanlegging',
      'Kalori- og makrosporing',
      'KI-oppskriftgenerering',
      'Flerspråklig KI-veiledning',
      'Videobasert coaching',
    ],
    problems: {
      kicker: 'Utfordringen',
      title: 'Helseveiledning er fragmentert, dyrt og vanskelig å holde fast på',
      sub: 'De fleste vet hva de bør gjøre. Problemet er å få det til å passe inn i en travel hverdag.',
      items: [
        {
          title: 'Fragmenterte løsninger',
          desc: 'Fitness- og kostholdsveiledning er spredt over flere apper og tjenester som ikke snakker sammen.',
        },
        {
          title: 'For dyre eksperter',
          desc: 'Personlige trenere og ernæringsfysiologer er effektive, men for kostbare for de fleste.',
        },
        {
          title: 'Manglende konsistens',
          desc: 'De fleste sliter med rutiner, oppfølging og å opprettholde sunne vaner over tid.',
        },
        {
          title: 'Tidskrevende planlegging',
          desc: 'Kalorisporing, måltidsplanlegging og valg av riktige øvelser krever mye tid og innsats.',
        },
      ],
    },
    platform: {
      kicker: 'Løsningen',
      title: 'Én plattform for hele helsereisen din',
      sub: 'FitGainers samler fitnesscoaching, kostholdsplanlegging, måltidssporing og KI-drevet støtte i én intelligent plattform som føles personlig, interaktiv og alltid tilgjengelig.',
      coachTitle: 'Din personlige KI-coach',
      coachDesc: 'Interaktiv veiledning og støtte i sanntid. Coachen foreslår treningsøkter, genererer oppskrifter og logger kalorier mens dere chatter.',
      coachPill: 'Svarer på under 2 sekunder',
      items: [
        {
          title: 'KI-oppskriftgenerering',
          desc: 'Lag sunne oppskrifter fra ingrediensene du har, eller fra et bilde av maten.',
        },
        {
          title: 'Videobasert coaching',
          desc: 'Interaktiv veiledning på video som tilpasser seg nivået ditt.',
        },
        {
          title: 'Naturlig samtale',
          desc: 'Snakk med coachen på språket du foretrekker.',
        },
        {
          title: 'Treningsbibliotek',
          desc: 'Øvelser organisert etter muskelgruppe, utstyr og vanskelighetsgrad.',
        },
        {
          title: 'Videoportal for trening',
          desc: 'HIIT, styrke, yoga, mobilitet og mye mer.',
        },
        {
          title: 'Sunt oppskriftsbibliotek',
          desc: 'Filtre for kalorier, kosthold, allergener og ingredienser.',
        },
      ],
    },
    nutrition: {
      kicker: 'Ernæringssporing',
      title: 'Gjør helsedata om til konkrete handlinger',
      sub: 'FitGainers hjelper deg å følge fremgangen din og holde deg ansvarlig, hver eneste dag.',
      features: [
        'Daglig kalorisporing',
        'Makrosporing',
        'Måltidslogging',
        'Oppskrift-til-sporing-integrasjon',
        'KI-assistert mat-estimering',
      ],
      calculatorTitle: 'Personlig målkalkulator',
      calculatorSub: 'Anbefalingene dine genereres basert på:',
      calculatorInputs: ['Alder', 'Kjønn', 'Vekt', 'Høyde', 'Aktivitetsnivå', 'Treningsmål'],
      macros: [
        { label: 'Protein', pct: 35 },
        { label: 'Karbohydrater', pct: 40 },
        { label: 'Fett', pct: 25 },
      ],
      dailyGoal: 'Dagens mål',
    },
    recipes: {
      kicker: 'Smart ernæring',
      title: 'Personlig ernæring gjort enkelt',
      sub: 'FitGainers hjelper deg å ta sunnere valg med intelligente verktøy for ernæring.',
      libraryTitle: 'Oppskriftsbibliotek',
      library: [
        'Sunde oppskrifter med avanserte filtre',
        'Støtte for kostholdspreferanser',
        'Allergenbevisste anbefalinger',
        'Kaloribevisste måltidsalternativer',
      ],
      outputTitle: 'Hver genererte oppskrift inneholder',
      output: [
        'Kalorier',
        'Protein, karbohydrater og fett',
        'Porsjonsstørrelser',
        'Allergener',
        'Tilberedningstid',
        'Full ingrediensliste',
      ],
    },
    grocery: {
      kicker: 'Smart handleplanlegging',
      title: 'Fra måltidsplan til smartere handletur',
      sub: 'Finn den rimeligste butikken for handlelisten din, uten å gå på akkord med ernæringsmålene dine.',
      steps: [
        'Generer handlelister automatisk fra valgte oppskrifter og måltidsplaner.',
        'Sammenlign priser på tvers av deltakende supermarkedkjeder.',
        'Se hvilket supermarked som gir lavest totalpris for hele listen.',
        'Få estimert totalbeløp per supermarked før du handler.',
        'Ta sunnere valg mens du holder deg innen budsjettet.',
        'Kombiner måltidsplanlegging, ernæring og kostnadsoptimalisering i én sømløs opplevelse.',
      ],
    },
    vision: {
      kicker: 'Vår visjon',
      title: 'Vi bygger fremtiden for KI-drevet velvære',
      statement: 'Å gjøre personlig fitness- og ernæringscoaching tilgjengelig for alle, gjennom intelligent og rimelig teknologi.',
      cards: [
        {
          title: 'Tilgjengelig i skala',
          desc: 'Målet er å gjøre premium helsesupport tilgjengelig for alle, overalt.',
        },
        {
          title: 'KI-lederskap',
          desc: 'Vi bygger Europas ledende KI-partner for helse og velvære.',
        },
        {
          title: 'Strategisk investering',
          desc: 'Investeringer går til produktutvikling, KI-infrastruktur og vekst.',
        },
      ],
    },
    cta: {
      title: 'Klar til å trene smartere?',
      sub: 'Bli med tusenvis av brukere som allerede har gjort FitGainers til sin personlige helsepartner.',
      button: 'Start med FitGainers',
      note: 'Ingen binding. Avslutt når du vil.',
    },
    footer: {
      blurb: 'FitGainers er en KI-drevet fitness- og ernæringsplattform med personlige treningsøkter, måltidsplanlegging, kalorisporing og KI-genererte oppskrifter. Tjenesten koster kr. 199,- per måned inkludert mva. og belastes via mobilregningen din. Abonnementet er løpende og kan sies opp når som helst. For å avslutte abonnementet, send GAINERS STOPP via SMS til 2210. Du mottar alltid en gratis bekreftelse på oppsigelsen. Aldersgrense 18 år. Ved spørsmål, kontakt oss på help@niffomobile.com.',
      links: [
        { label: 'Vilkår og betingelser', href: '/vilkar.html' },
        { label: 'Personvernerklæring', href: '/personvern.html' },
        { label: 'Kontakt', href: 'mailto:help@niffomobile.com' },
      ],
      contactTitle: 'Kontakt',
      company: 'Niffo Mobile B.V.',
      address: 'Stationsplein 28, 1382 AD Weesp, Nederland',
      email: 'help@niffomobile.com',
      copyright: 'Copyright © 2026 FitGainers | KI-drevet fitness | Med enerett.',
    },
  },

  en: {
    header: {
      login: 'Login',
      languageLabel: 'Language',
    },
    hero: {
      badge: 'AI-powered fitness and nutrition',
      line1: 'TRAIN',
      line2: 'SMARTER.',
      line3: 'LIVE STRONGER.',
      sub: 'FitGainers brings personalized workouts, meal planning, calorie tracking and AI-generated recipes together in one intelligent platform. Your personal coach, available 24/7 in your own language.',
      cta: 'Get started now',
      ctaSecondary: 'How it works',
      stats: [
        { value: '24/7', label: 'AI coach available' },
        { value: '1000+', label: 'Healthy recipes' },
        { value: '500+', label: 'Workout videos' },
      ],
      chat: [
        { from: 'user', text: 'What should I eat after today’s strength session?' },
        { from: 'ai', text: 'Based on your workout I recommend 30 g of protein within 45 minutes. Want me to create a recipe from the ingredients you have at home?' },
        { from: 'user', text: 'Yes, please!' },
      ],
      recipeCard: {
        tag: 'AI-generated recipe',
        title: 'High-protein chicken bowl',
        kcal: '420 kcal',
        protein: '32 g protein',
        time: '15 min',
      },
      floating: [
        { title: 'Calories logged', value: '1,840 / 2,200 kcal' },
        { title: 'New session ready', value: 'HIIT, 20 min' },
      ],
    },
    ticker: [
      'Personalized workouts',
      'Nutrition and meal planning',
      'Calorie and macro tracking',
      'AI recipe generation',
      'Multilingual AI guidance',
      'Video-based coaching',
    ],
    problems: {
      kicker: 'The challenge',
      title: 'Health guidance is fragmented, expensive and hard to stick with',
      sub: 'Most people know what they should do. The problem is making it fit into a busy everyday life.',
      items: [
        {
          title: 'Fragmented solutions',
          desc: 'Fitness and nutrition guidance is scattered across multiple apps and services that do not talk to each other.',
        },
        {
          title: 'Experts cost too much',
          desc: 'Personal trainers and nutrition experts are effective, but remain too expensive for many people.',
        },
        {
          title: 'Lack of consistency',
          desc: 'Most people struggle with routines, accountability and maintaining healthy habits over time.',
        },
        {
          title: 'Time-consuming planning',
          desc: 'Tracking calories, planning meals and choosing effective workouts takes significant time and effort.',
        },
      ],
    },
    platform: {
      kicker: 'The solution',
      title: 'One platform for your entire health journey',
      sub: 'FitGainers unites fitness coaching, nutrition planning, meal tracking and AI-powered support in a single intelligent platform that feels personal, interactive and always available.',
      coachTitle: 'Your personal AI coach',
      coachDesc: 'Interactive guidance and real-time support. The coach suggests workouts, generates recipes and logs calories while you chat.',
      coachPill: 'Replies in under 2 seconds',
      items: [
        {
          title: 'AI recipe generation',
          desc: 'Create healthy recipes from the ingredients you have, or from a photo of your food.',
        },
        {
          title: 'Video-based coaching',
          desc: 'Interactive video guidance that adapts to your level.',
        },
        {
          title: 'Natural conversation',
          desc: 'Talk to your coach in your preferred language.',
        },
        {
          title: 'Exercise library',
          desc: 'Exercises organized by muscle group, equipment and difficulty.',
        },
        {
          title: 'Workout video portal',
          desc: 'HIIT, strength, yoga, mobility and much more.',
        },
        {
          title: 'Healthy recipe library',
          desc: 'Filters for calories, diet, allergens and ingredients.',
        },
      ],
    },
    nutrition: {
      kicker: 'Nutrition tracking',
      title: 'Turn health data into concrete action',
      sub: 'FitGainers helps you monitor progress and stay accountable, every single day.',
      features: [
        'Daily calorie tracking',
        'Macro tracking',
        'Meal logging',
        'Recipe-to-tracker integration',
        'AI-assisted food estimation',
      ],
      calculatorTitle: 'Personal goal calculator',
      calculatorSub: 'Your recommendations are generated based on:',
      calculatorInputs: ['Age', 'Gender', 'Weight', 'Height', 'Activity level', 'Fitness objectives'],
      macros: [
        { label: 'Protein', pct: 35 },
        { label: 'Carbs', pct: 40 },
        { label: 'Fat', pct: 25 },
      ],
      dailyGoal: 'Today’s goal',
    },
    recipes: {
      kicker: 'Smart nutrition',
      title: 'Personalized nutrition made simple',
      sub: 'FitGainers helps you make healthier food choices through intelligent nutrition tools.',
      libraryTitle: 'Recipe library',
      library: [
        'Healthy recipes with advanced filters',
        'Dietary preference support',
        'Allergy-aware recommendations',
        'Calorie-conscious meal options',
      ],
      outputTitle: 'Every generated recipe includes',
      output: [
        'Calories',
        'Protein, carbs and fats',
        'Serving sizes',
        'Allergens',
        'Preparation time',
        'Full ingredients list',
      ],
    },
    grocery: {
      kicker: 'Smart grocery planning',
      title: 'From meal plan to smarter shopping',
      sub: 'Find the most affordable supermarket for your grocery list while staying on track with your nutrition goals.',
      steps: [
        'Automatically generate grocery lists from selected recipes and meal plans.',
        'Compare grocery prices across participating supermarket chains.',
        'See which supermarket offers the lowest total cost for the complete list.',
        'View estimated total spending per supermarket before you shop.',
        'Make healthier choices while staying within budget.',
        'Combine meal planning, nutrition and cost optimization in one seamless experience.',
      ],
    },
    vision: {
      kicker: 'Our vision',
      title: 'Building the future of AI-powered wellness',
      statement: 'To make personalized fitness and nutrition coaching accessible to everyone through intelligent, affordable technology.',
      cards: [
        {
          title: 'Accessible at scale',
          desc: 'Our goal is to make premium health support accessible to everyone, everywhere.',
        },
        {
          title: 'AI leadership',
          desc: 'We are building Europe’s leading AI companion for health and wellness.',
        },
        {
          title: 'Strategic investment',
          desc: 'Funding supports product development, AI infrastructure and growth.',
        },
      ],
    },
    cta: {
      title: 'Ready to train smarter?',
      sub: 'Join thousands of users who have already made FitGainers their personal health companion.',
      button: 'Start with FitGainers',
      note: 'No commitment. Cancel anytime.',
    },
    footer: {
      blurb: 'FitGainers is an AI-powered fitness and nutrition platform with personalized workouts, meal planning, calorie tracking and AI-generated recipes. The service costs NOK 199 per month including VAT and is charged via your mobile bill. The subscription is ongoing and can be cancelled at any time. To cancel your subscription, send GAINERS STOP via SMS to 2210. You will always receive a free confirmation of your cancellation. Age limit 18 years. For questions, contact us at help@niffomobile.com.',
      links: [
        { label: 'Terms and conditions', href: '/vilkar.html' },
        { label: 'Privacy policy', href: '/personvern.html' },
        { label: 'Contact', href: 'mailto:help@niffomobile.com' },
      ],
      contactTitle: 'Contact',
      company: 'Niffo Mobile B.V.',
      address: 'Stationsplein 28, 1382 AD Weesp, Netherlands',
      email: 'help@niffomobile.com',
      copyright: 'Copyright © 2026 FitGainers | AI-powered fitness | All rights reserved.',
    },
  },
};
